
export const IDLE_TIME_KEY: string = 'idleTime';
export const IDLE_TIME_IN_MINUTES = 10;

export const getIdleTimeInMinutes = () => {
    return Number.parseInt(localStorage.getItem(IDLE_TIME_KEY) || '') || IDLE_TIME_IN_MINUTES
}
